import { useState, useEffect } from "react";

const useDelayedLoading = (isLoading, delay = 300) => {
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    let timer;
    if (isLoading) {
      timer = setTimeout(() => setShowLoading(true), delay);
    } else {
      setShowLoading(false);
    }
    return () => clearTimeout(timer);
  }, [isLoading, delay]);

  return showLoading;
};

export default useDelayedLoading;
